var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKotlinlangIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 8.64 8.633",
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    x1: 2.039,
    y1: 11.659,
    x2: 9.95,
    y2: 3.748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.108,
    stopColor: "#c757bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.173,
    stopColor: "#cd5ca9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#e8744f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.716,
    stopColor: "#f88316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.823,
    stopColor: "#ff8900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "B",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#00afff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.694,
    stopColor: "#5282ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#945dff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "C",
    x1: 3.369,
    y1: 6.189,
    x2: 6.073,
    y2: 3.484,
    xlinkHref: "#B"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#B",
    id: "D",
    x1: 6.184,
    y1: 13.878,
    x2: 10.04,
    y2: 10.022
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.016327 0 0 1.016327 -3.52726 -3.909123)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.74 3.843L3.47 8.33v4.013l4.262-4.27 4.24-4.232z",
    fill: "url(#A)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.47 12.344l4.262-4.27 4.24 4.27z",
    fill: "url(#D)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.47 3.843H7.74L3.47 8.33z",
    fill: "url(#C)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKotlinlangIcon);
export default __webpack_public_path__ + "static/media/kotlinlang-icon.be208ca7096c5d983cba9e87c90681ee.svg";
export { ForwardRef as ReactComponent };